import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import IntroductoryCarouselView from './IntroductoryCarouselView';
import { INTRODUCTION_STEPS } from '../../../../constants';
import { DASHBOARD_PATH } from '../../../../constants/paths';
import useUpdateProfile from '../../../../hooks/queries/useUpdateProfile';

const IntroductoryCarouselContainer = () => {
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const maxSteps = INTRODUCTION_STEPS.length;

  const { updateProfileDetails } = useUpdateProfile();

  const handleNext = () => {
    const isLastStep = activeStep === maxSteps - 1;
    if (isLastStep) {
      updateProfileDetails({ patient_platform_first_login: false });
      navigate(DASHBOARD_PATH, { replace: true });
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    updateProfileDetails({ patient_platform_first_login: false });
    navigate(DASHBOARD_PATH, { replace: true });
  };

  return (
    <IntroductoryCarouselView
      activeStep={activeStep}
      steps={INTRODUCTION_STEPS}
      maxSteps={maxSteps}
      handleNext={handleNext}
      handleBack={handleBack}
      handleSkip={handleSkip}
    />
  );
};

export default IntroductoryCarouselContainer;
